export default __webpack_public_path__ + "static/media/Atmel.7db3910d.png";